import React, { useCallback, useContext, useEffect, useState } from "react";
import { FireBaseContext } from "../../Context/FireBase";
import { where, query, onSnapshot } from "firebase/firestore";
import { HelperContext } from "../../Context/HelperContext";
import { TablePagination, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

function UserReport() {
  const { getData, UserRef, EventRefrence } = useContext(FireBaseContext);
  const { FormateCost } = useContext(HelperContext);
  const [informations, setInformations] = useState([]);
  const [selectedFranchise, setSelectedFranchise] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  // const fetchData = useCallback(() => {
  //   getData(UserRef, setInformations);
  //   // setTimeout(() => {
  //   //   setLoading(false);
  //   // }, 1000);

  // }, [UserRef, getData]);

  const fetchData = useCallback(() => {
    getData(UserRef, setInformations);
    setLoading(false);
  }, [UserRef, getData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const fetchEventData = useCallback(() => {
    if (informations.length > 0) {
      const updatedInformations = [...informations];

      informations.forEach((item, index) => {
        const q = query(EventRefrence, where("CreatedByID", "==", item.ID));

        onSnapshot(q, (snapshot) => {
          const newData = snapshot.docs.map((doc) => doc.data());
          const totalEvents = newData.length;
          const eventCost = newData.reduce(
            (acc, event) => acc + (event.eventCost || 0),
            0
          );
          const EventCurrency =
            newData.length > 0 ? newData[0].EventCurrency : null;

          updatedInformations[index] = {
            ...item,
            totalEvents,
            eventCost,
            EventCurrency,
          };

          setInformations([...updatedInformations]);
        });
      });
    }
  }, [informations, EventRefrence]);

  useEffect(() => {
    fetchEventData();
  }, [fetchEventData]);

  const handleFranchiseChange = (event) => {
    setSelectedFranchise(event.target.value);
  };
  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const findTrueKey = (obj) => {
    for (const [key, value] of Object.entries(obj)) {
      if (value === true) {
        return key;
      }
    }
    return null; // or handle the case where no true value is found
  };

  const filteredRows = informations.filter((row) => {
    // Handle filtering by franchise if selectedFranchise is set
    const franchise = row.franchiseType?.toLowerCase() || "";
    const role = findTrueKey(row.Role)?.toLowerCase() || "";

    return (
      (selectedRole === "" || role === selectedRole) &&
      (selectedFranchise === "" ||
        franchise === selectedFranchise.toLowerCase())
    );
  });

  const exportToExcel = (data) => {
    // Create a new workbook and a new worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "All Users");

    let filename = "users_data.xlsx";
    if (selectedFranchise && selectedRole) {
      filename = `${selectedRole}_${selectedFranchise}.xlsx`;
    } else if (selectedFranchise) {
      filename = `${selectedFranchise}.xlsx`;
    } else if (selectedRole) {
      filename = `${selectedRole}.xlsx`;
    }
    XLSX.writeFile(wb, filename);
  };

  const handleExport = () => {
    // Call the export function with the filtered rows
    const excelFilter = filteredRows.map((row) => {
      let userRole = "";
      if (row.Role.admin) {
        userRole = "admin";
      } else if (row.Role.manager) {
        userRole = "manager";
      } else if (row.Role.user) {
        userRole = "user";
      }
      return {
        Name: row.Name,
        Email: row.Email,
        "Franchise Type": row.franchiseType,
        Role: userRole,
        "Total Events": row.totalEvents,
        // "Total Events Cost": row.eventCost,
      };
    });
    if (excelFilter.length) {
      exportToExcel(excelFilter);
    } else {
      toast.error("There is No data to Export", { autoClose: 4000 });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="d-flex flex-column container-fluid container-md gap-3">
      <ToastContainer />
      <h2 className="mb-4">Users Report</h2>

      {loading ? (
        <div
          className="w-100 flex justify-center items-center"
          style={{ height: "calc(100vh - 250px) " }}
        >
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      ) : (
        <div className="bg-white p-3 rounded-md ">
          <div className="flex justify-between items-center">
            <div className="flex justify-start items-center gap-4">
              <div className="w-80">
                <label
                  className="block text-black text-sm font-bold mb-2 w-fit"
                  htmlFor="select2"
                >
                  Filter Franchise
                </label>
                <TextField
                  select
                  value={selectedFranchise}
                  onChange={handleFranchiseChange}
                  SelectProps={{
                    native: true,
                  }}
                  variant="outlined"
                  className="border-bottom w-100"
                >
                  <option value="">All</option>
                  <option value="Immunology & Neuroscience">
                    Immunology & Neuroscience
                  </option>
                  <option value="gtx">Gtx</option>
                  <option value="oncology">Oncology</option>
                  <option value="cardiovascular">Cardiovascular</option>
                  <option value="medical">Medical</option>
                  <option value="Value, Access & KAM">
                    Value, Access & KAM
                  </option>
                  <option value="BE&E">BE&E</option>
                </TextField>
              </div>
              <div className="w-80">
                <label
                  className="block text-black text-sm font-bold mb-2 w-fit"
                  htmlFor="select2"
                >
                  Filter Role
                </label>
                <TextField
                  select
                  value={selectedRole}
                  onChange={handleRoleChange}
                  SelectProps={{
                    native: true,
                  }}
                  variant="outlined"
                  className="border-bottom w-100"
                >
                  <option value="">All</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                  <option value="manager">Manager</option>
                </TextField>
              </div>
            </div>

            <div className="px-3">
              <button
                onClick={handleExport}
                className="btn btn-success text-white"
              >
                <i className="fa-solid fa-file-arrow-down fs-5 text-white mr-2"></i>
                <span>EXPORT</span>
              </button>
            </div>
          </div>

          <div className="overflow-x-auto mt-4 mb-6 ">
            <table className="min-w-full bg-white  rounded-lg text-center ">
              <thead className=" text-black  text-lg border-b border-gray-200">
                <tr>
                  <th className="w-1/6 py-3 px-4">Name</th>
                  <th className="w-1/6 py-3 px-4">Franchise</th>
                  <th className="w-1/6 py-3 px-4">Total Events</th>
                  {/* <th className="w-1/6 py-3 px-4">Events Cost</th> */}
                </tr>
              </thead>
              <tbody className="">
                {filteredRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <tr
                      key={index}
                      className="text-blueColor font-normal border-b  odd:bg-white  even:bg-gray-100 "
                    >
                      <td className="py-3 px-4">{item.Name}</td>
                      <td className="py-3 px-4">{item.franchiseType}</td>
                      <td className="py-3 px-4">{item.totalEvents}</td>
                      {/* <td className="py-3 px-4">
                        {FormateCost(
                          item.eventCost,
                          item.EventCurrency || "Saudi Riyal"
                        )}
                      </td> */}
                    </tr>
                  ))}
              </tbody>
            </table>

            <div className="my-3">
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserReport;

// useEffect(() => {
//   if (informations.length > 0) {
//     const updatedInformations = [...informations]; // Clone the current state

//     informations.forEach((item, index) => {
//       const q = query(EventRefrence, where("CreatedByID", "==", item.ID));

//       onSnapshot(q, (snapshot) => {
//         const newData = snapshot.docs.map((doc) => doc.data());
//         const totalEvents = newData.length;
//         const eventCost = newData.reduce(
//           (acc, event) => acc + (event.eventCost || 0),
//           0
//         );
//         const EventCurrency = newData.EventCurrency;

//         updatedInformations[index] = {
//           ...item,
//           totalEvents,
//           eventCost,
//           EventCurrency,
//         };

//         // Update state after processing all users
//         setInformations([...updatedInformations]);
//       });
//     });
//   }
// }, [informations, EventRefrence]);
